<template>
  <base-draggable-modal
      name="base_modal_fields"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_modal_fields">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <base-table-fields ref="base_table_fields" :current_model="selected_model" :modal="true"/>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button v-if="canEdit" :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseTableFields from "./BaseTableFields";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  props: ["selected_model"],
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    BaseTableFields,
    PhFloppyDisk, PhX,
  },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.fields,
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('base_modal_fields');
    },
    save() {
      this.$refs.base_table_fields.save();
    },
    reset() {
      this.$emit('refresh');
      this.closeModal('base_modal_fields');
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
  },
};
</script>